import { Component, OnInit } from '@angular/core';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';
import { SearchMenuService } from 'src/app/services/search-menu/search-menu.service';

@Component({
    selector: 'xqnr-q-placeholder',
    templateUrl: './q-placeholder.component.pug',
    styleUrls: ['./q-placeholder.component.scss'],
    standalone: false
})
export class QPlaceholderComponent implements OnInit {
  constructor(
    private backdrop: BackdropService,
    private searchMenu: SearchMenuService
  ) {}

  ngOnInit(): void {}

  searchClickd() {
    this.backdrop.show();
    this.searchMenu.show();
  }
}
